/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompleteCardLinkWithMicroAuthRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CompleteCardLinkWithMicroAuth.pb'
import {CompleteCardLinkWithMicroAuthResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CompleteCardLinkWithMicroAuth.pb'


export const completeCardLinkWithMicroAuth = (request:CompleteCardLinkWithMicroAuthRequest, options?: CashRequestOptions) => post<CompleteCardLinkWithMicroAuthRequest, CompleteCardLinkWithMicroAuthResponse>("/2.0/cash/complete-card-link-with-micro-auth", request, {...options, rejectOnError: true })